import { Component, inject } from '@angular/core';
import { KbGetAQuoteService } from '../kb-get-aquote.service';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-quote-popup',
  templateUrl: './quote-popup.component.html',
  styleUrls: ['./quote-popup.component.scss'],
  standalone: false
})
export class QuotePopupComponent {
  public quoteService = inject(KbGetAQuoteService);
  subscription = new Subscription();
  constructor(public dialogRef: MatDialogRef<QuotePopupComponent>) {

  }

  yesClicked() {
    if (this.quoteService.popUpCaller?.calledBy == 'SUBMIT' && this.quoteService.popUpCaller?.source == 'side-panel') {
      this.subscription.add(this.quoteService.submitQuote(this.quoteService.popUpCaller?.id).subscribe((data: any) => {
        data.type = 'submit';
        this.dialogRef.close(data);
      }));
    } else if (this.quoteService.popUpCaller?.calledBy !== 'SUBMITFROMEDIT' && this.quoteService.popUpCaller?.calledBy !== 'CANCELFROMEDIT') {
      this.subscription.add(this.quoteService.cancelQuote(this.quoteService.popUpCaller?.id).subscribe(data => {
        this.dialogRef.close(data);
      }));
    }
  }
  ngOnDestroy(): void {
    // Unsubscribe from the scroll event
    this.subscription.unsubscribe();
  }

}